const swiperImg = [
  "/swiper/swiper1.jpg",
  "/swiper/swiper2.jpg",
  "/swiper/swiper3.jpg",
];
const leftTime = "/circlecentent.png";
const cosmoLogo = "/cosmo.jpg";
const partners = "/partners.jpg";
const mappp = "/mappp.png";
const mouldCategories = [
  {
    categoryName: "Mold Categories",
    categoryId: 6,
    coverImage: "/moulds/0.jpg",
    banner: "/moulds/banner.jpg",
    titlePrefix: "Customization",
  },
  {
    categoryName: "Product Categories",
    categoryId: 5,
    coverImage: "/industrial/0.jpg",
    banner: "/industrial/banner.jpg",
    titlePrefix: "Customization",
  },
  {
    categoryName: "Mold Accessories",
    categoryId: 3,
    coverImage: require("../assets/accessories.jpg"),
    banner: "/industrial/banner.jpg",
    titlePrefix: "Customization",
  },
];
//   // {
//   //   titlePrefix: "Full Category of",
//   //   title: "Product Categories",
//   //   coverImage: "/moulds/0.jpg",
//   //   banner: "/moulds/banner.jpg",
//   //   id: 0,
//   //  moulds: [
//   //    {
//   //      id: 1,
//   //      img: "/batch/1.jpg",
//   //      name: "Die Casting Products",
//   //      introduce: "Gearbox Oil Housing",
//   //    },
//   //    {
//   //      id: 2,
//   //      img: "/batch/2.jpg",
//   //      name: "Die Casting Products",
//   //      introduce: "5G Communication Piece Filter",
//   //    },
//   //    {
//   //      id: 3,
//   //      img: "/batch/3.jpg",
//   //      name: "Die Casting Products",
//   //      introduce: "Automobile Body Structural Parts",
//   //    },
//   //    {
//   //      id: 4,
//   //      img: "/batch/4.jpg",
//   //      name: "Die Casting Products",
//   //      introduce: "Die Casting Products",
//   //    },
//   //    {
//   //      id: 5,
//   //      img: "/batch/5.jpg",
//   //      name: "Hardware and Plastic Products",
//   //      introduce: "Automobile Exterior Accessories",
//   //    },
//   //    {
//   //      id: 6,
//   //      img: "/batch/6.jpg",
//   //      name: "Hardware and Plastic Products",
//   //      introduce: "Automobile Interior Accessories",
//   //    },
//   //    {
//   //      id: 7,
//   //      img: "/batch/7.jpg",
//   //      name: "Automobile Interior Accessories",
//   //      introduce: "Stamping Strips & Stamping Die Material Belt Products",
//   //    },
//   //    {
//   //      id: 8,
//   //      img: "/batch/8.jpg",
//   //      name: "Hardware and Plastic Products",
//   //      introduce:
//   //        "Automotive Functional Parts & Car Horn, Pedal, Ignition Coil, Sensor, Coil Frame, Lock Limiter",
//   //    },
//   //  ],
//   // },
//   {
//     titlePrefix: "Customization",
//     title: "Mold Categories",
//     coverImage: "/moulds/0.jpg",
//     banner: "/batch/banner.jpg",
//     id: 1,
//     moulds: [
//       {
//         id: 1,
//         img: "/moulds/1.jpg",
//         name: "Stamping Mold",
//         introduce: `Professional High Precision Terminal Aluminum Progressive Stamping Die Mold  `,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 2,
//         img: "/moulds/2.jpg",
//         name: "Die Casting Mould",
//         introduce: `Partial Aluminum Mold Casting of Engine Bottom Shell`,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 3,
//         img: "/moulds/3.jpg",
//         name: "Plastic Mould",
//         introduce: `Hot Runner Molds for Water Pump Bases`,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 4,
//         img: "/moulds/4.jpg",
//         name: "Plastic Mould",
//         introduce: `Car Hub Bumper Plastic Automotive Parts Mould `,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 5,
//         img: "/moulds/5.jpg",
//         name: "Plastic Mould",
//         introduce: `Mobile Phone Case Rear Mould`,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 6,
//         img: "/moulds/6.jpg",
//         name: "Plastic Mould",
//         introduce: `Automotive Plastic lamp Car Headlight Auto Mould `,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 7,
//         img: "/moulds/7.jpg",
//         name: "Plastic Mould",
//         introduce: `Injection Molds for Washing Machine Inner Tubs  `,
//         categoryName: "Mold Categories",
//       },
//       {
//         id: 8,
//         img: "/moulds/8.jpg",
//         name: "Other Moulds",
//         introduce: `Various Mold Manufacturing `,
//         categoryName: "Mold Categories",
//       },
//     ],
//   },
//   {
//     titlePrefix: "Customization",
//     title: "Product Categories",
//     coverImage: "/industrial/0.jpg",
//     banner: "/industrial/banner.jpg",
//     id: 2,
//     moulds: [
//       {
//         id: 1,
//         img: "/industrial/1.jpg",
//         name: "PC",
//         categoryName: "Product Categories",
//         introduce: `Customized Metal Innovative Notebook Portable PC`,
//       },
//       {
//         id: 2,
//         img: "/industrial/2.jpg",
//         name: "CT MAGNETIC Resonance Equipment",
//         introduce: `The System Adopts the International Advanced Hardware Platform Together With Ergonomic Operating Software Design, Its Advanced Scan Sequences and`,
//         categoryName: "Product Categories",
//       },
//       {
//         id: 3,
//         img: "/industrial/3.jpg",
//         name: "Air-Conditioner",
//         introduce: `Inverter Air-Conditioner, Best Selling High Quality Home Split Wall Mounted Air Conditioner`,
//         pdf: "/pdf/air-conditioner.PDF",
//         categoryName: "Product Categories",
//       },
//       {
//         id: 4,
//         img: "/industrial/4.jpg",
//         name: "Bumper",
//         introduce: `Bumper (Front and back), Various Models Can Be Customized And Higher Safety Factor`,
//         categoryName: "Product Categories",
//       },
//       {
//         id: 5,
//         img: "/industrial/5.jpg",
//         name: "Engine Cylinder Block",
//         introduce: `Engine Cylinder Block, Engine Block With Sufficient Strength And Rigidity And Long Service Life`,
//         categoryName: "Product Categories",
//       },
//       {
//         id: 6,
//         img: "/industrial/6.jpg",
//         name: "Gearbox",
//         introduce: `Gearbox, High Precision Gearbox, Reducer For Servo Motor, Easy Assembly, Long Life`,
//         categoryName: "Product Categories",
//       },
//       {
//         id: 7,
//         img: "/industrial/7.jpg",
//         name: "Liftgate Trim",
//         introduce: `Liftgate Trim, the Tail Door Panel Auto Body Parts High Quality Car Liftgate Trim
// `,
//         categoryName: "Product Categories",
//       },
//       {
//         id: 8,
//         img: "/industrial/8.jpg",
//         name: "Municipal Machinery",
//         introduce: `
// Municipal Machinery, Support Customized Hydraulic Excavators, Bulldozers, Vibratory Rollers, Graders, Wheel Loaders, Dump Trucks, Sprinklers, Tank Trucks And Other Municipal Machinery`,
//         categoryName: "Product Categories",
//       },
//     ],
//   },
//   // {
//   //   titlePrefix: "",
//   //   title: "Epidemic Prevention and Control Supplies",
//   //   coverImage: "/epidemic/0.jpg",
//   //   banner: "/epidemic/banner.jpg",
//   //   id: 3,
//   //   moulds: [
//   //     {
//   //       id: 1,
//   //       img: "/epidemic/1.jpg",
//   //       name: "Smart Temperature Measurement and Disinfection Channel",
//   //       introduce: "Smart Temperature Measurement and Disinfection Channel",
//   //       pdf: "/pdf/tunnel.pdf",
//   //       video: require("./video/tunnel.mp4"),
//   //     },
//   //     {
//   //       id: 2,
//   //       img: "/epidemic/2.jpg",
//   //       name: "Sanitization Channel",
//   //       introduce: "Sanitization Channel",
//   //     },
//   //     {
//   //       id: 3,
//   //       img: "/epidemic/3.jpg",
//   //       name: "Disinfectant Generator",
//   //       introduce: "Disinfectant Generator",
//   //     },
//   //     {
//   //       id: 4,
//   //       img: "/epidemic/4.jpg",
//   //       name: "Modular Intelligent Medical Isolation Cabin",
//   //       introduce: "Modular Intelligent Medical Isolation Cabin",
//   //       pdf: "/pdf/cofferdams.pdf",
//   //       video: require("./video/cofferdams.mp4"),
//   //     },
//   //     {
//   //       id: 5,
//   //       img: "/epidemic/5.jpg",
//   //       name: "Replaceable Multi-function silicone Mask",
//   //       introduce: "Replaceable Multi-function silicone Mask",
//   //     },
//   //     {
//   //       id: 6,
//   //       img: "/epidemic/6.jpg",
//   //       name: "Protective Clothing",
//   //       introduce: "Protective Clothing",
//   //     },
//   //     {
//   //       id: 7,
//   //       img: "/epidemic/7.jpg",
//   //       name: "Disinfecting Robot",
//   //       introduce: "Disinfecting Robot",
//   //       detailImages: [
//   //         require("../assets/images/disinfection-robot/1.jpg"),
//   //         require("../assets/images/disinfection-robot/2.jpg"),
//   //         require("../assets/images/disinfection-robot/3.jpg"),
//   //         require("../assets/images/disinfection-robot/4.jpg"),
//   //       ],
//   //       child: {
//   //         id: 9,
//   //         img: "/epidemic/hotel.jpg",
//   //         name: "Hotel service robot",
//   //         introduce: "Hotel service robot",
//   //         detailImages: [
//   //           require("../assets/images/hotel/1.jpg"),
//   //           require("../assets/images/hotel/2.jpg"),
//   //           require("../assets/images/hotel/3.jpg"),
//   //           require("../assets/images/hotel/4.jpg"),
//   //           require("../assets/images/hotel/5.jpg"),
//   //           require("../assets/images/hotel/6.jpg"),
//   //           require("../assets/images/hotel/7.jpg"),
//   //           require("../assets/images/hotel/8.jpg"),
//   //           require("../assets/images/hotel/9.jpg"),
//   //           require("../assets/images/hotel/10.jpg"),
//   //           require("../assets/images/hotel/11.jpg"),
//   //           require("../assets/images/hotel/12.jpg"),
//   //           require("../assets/images/hotel/13.jpg"),
//   //           require("../assets/images/hotel/14.jpg"),
//   //           require("../assets/images/hotel/15.jpg"),
//   //           require("../assets/images/hotel/16.jpg"),
//   //           require("../assets/images/hotel/17.jpg"),
//   //           require("../assets/images/hotel/18.jpg"),
//   //           require("../assets/images/hotel/19.jpg"),
//   //           require("../assets/images/hotel/20.jpg"),
//   //           require("../assets/images/hotel/21.jpg"),
//   //           require("../assets/images/hotel/22.jpg"),
//   //           require("../assets/images/hotel/23.jpg"),
//   //           require("../assets/images/hotel/24.jpg"),
//   //           require("../assets/images/hotel/25.jpg"),
//   //           require("../assets/images/hotel/26.jpg"),
//   //           require("../assets/images/hotel/27.jpg"),
//   //           require("../assets/images/hotel/28.jpg"),
//   //           require("../assets/images/hotel/29.jpg"),
//   //         ],
//   //       },
//   //     },
//   //     {
//   //       id: 8,
//   //       img: "/epidemic/8.jpg",
//   //       name: "Electret Masterbatch",
//   //       introduce: "Electret Masterbatch",
//   //     },
//   //   ],
//   // },
// ];
//
const list = [
  {
    name: "Access control machine",
    categoryName: "Accesscontrolmachine",
    attachList: [
      {
        fileUrl: "/epidemic/Accesscontrolmachineone.jpg",
      },
    ],
    introduce: "Access control machine",
  },
  {
    name: "Disinfectant generator",
    categoryName: "Disinfectantgenerator",
    attachList: [
      {
        fileUrl: "/epidemic/Disinfectantgeneratorone.jpg",
      },
    ],
    introduce: "Disinfectant generator",
  },
  {
    name: "face recognition",
    categoryName: "facerecognition",
    attachList: [
      {
        fileUrl: "/epidemic/facerecognition.jpg",
      },
    ],
    introduce: "face recognition",
  },
  {
    name: "RV",
    categoryName: "RV",
    attachList: [
      {
        fileUrl: "/epidemic/RVone.jpg",
      },
    ],
    introduce: "RV",
  },
  {
    name: "Sanitization Channel",
    categoryName: "SanitizationChannel",
    attachList: [
      {
        fileUrl: "/epidemic/SanitizationChanelone.png",
      },
    ],
    introduce: "Sanitization Channel",
  },
];
export {
  swiperImg,
  leftTime,
  cosmoLogo,
  partners,
  mouldCategories,
  list,
  mappp,
};
